<template>
  <div class="top-wrapper">
    <h4>devis</h4>
    <div class="right">
      <a
        :href="pdfUrl"
        @click="onPdfClick"
        target="_blank"
        class="pdf-wrapper"
        v-if="!degraded"
        type="button"
      >
        <svg class="pdf-icon">
          <use xlink:href="#icon-download"></use>
        </svg>
        <span>sauvegarder mon devis en pdf</span>
      </a>
      <a
        v-show="mailto"
        :href="mailto"
        class="circle"
        aria-label="envoyer par email"
      >
        <svg class="email-icon">
          <use xlink:href="#icon-email"></use>
        </svg>
      </a>
    </div>
    <light-box
      @close="hideLightBox"
      :visible="showLightBox"
    >
      <pop-up-login v-if="!userIsLogged" />
      <div
        v-else
        class="text-popin"
      >
        {{ $t('components.quotation_top.missing_cdw') }}
      </div>
    </light-box>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { format } from 'date-fns'
import LightBox from '../../shared/LightBox'
import PopUpLogin from '../../Identification/PopUp/PopUpLogin'

export default {
  name: 'QuotationTop',
  components: {
    LightBox,
    PopUpLogin,
  },
  data() {
    return {
      showLightBox: false,
    }
  },
  props: {
    degraded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      pdfUrl: (state) => state.quotation.pdfUrl,
      cdw: (state) => state.quotation.cdw,
      booking: (state) => state.booking,
      /* eslint-disable-next-line camelcase */
      vehicle: (state) => state.vehicles.set?.storeVehicle?.semi_clair,
    }),
    ...mapGetters({
      userIsLogged: 'auth/userIsLogged',
      vehicleCardsProfileRequested: 'user/isGetProfileRequested',
    }),
    isCdWSelected() {
      return typeof this.cdw !== 'undefined'
    },
    mailtoInfo() {
      /* eslint-disable camelcase */
      return {
        defaultMessage: this.$t('components.quotation_top.mailto'),
        pickupDate: this.booking.pickUp.date,
        pickupTime: this.booking.pickUp.time,
        pickupRrf: this.booking.pickUp?.business?.code_rrf,
        postalCode: this.booking.pickUp?.business?.postal_code,
        dropDate: this.booking.drop.date,
        dropTime: this.booking.drop.time,
        dropRrf: this.booking.drop?.business?.code_rrf,
        vehicle: this.vehicle,
      }
      /* eslint-enable camelcase */
    },
    mailtoInfoReady() {
      return Object.entries(this.mailtoInfo).findIndex((entry) => !entry[1]) === -1
    },
    mailto() {
      if (!this.mailtoInfoReady) {
        return false
      }
      return this.generateMailto({
        ...this.mailtoInfo,
      })
    },
  },
  methods: {
    onPdfClick(ev) {
      this.analytics()
      if (this.userIsLogged && this.isCdWSelected) {
        return
      }

      ev.preventDefault()
      this.showLightBox = true
    },
    hideLightBox() {
      this.showLightBox = false
    },
    generateMailto({
      defaultMessage, pickupDate, pickupTime, dropDate, dropTime, postalCode, pickupRrf, dropRrf, vehicle,
    }) {
      const fmt = 'yyyyMMdd'
      const pickupHour = pickupTime.substring(0, 2)
      const dropHour = dropTime.substring(0, 2)
      const paddedPickupRrf = pickupRrf.padStart(8, '0')
      const paddedDropRrf = dropRrf.padStart(8, '0')

      return `${defaultMessage}https%3A%2F%2F${window.location.host}%2Fdevis%3FORIGIN%3Dpartage-eml%26date_depart%3D${format(pickupDate, fmt)}%26heure_depart%3D${pickupHour}%26date_retour%3D${format(dropDate, fmt)}%26heure_retour%3D${dropHour}%26code_postal%3D${postalCode}%26code_rrf%3D${paddedPickupRrf}%26code_rrf_retour%3D${paddedDropRrf}%26modele%3D${vehicle}`
    },
    analytics() {
      if (!window.dataLayer) {
        return
      }
      const event = 'download'
      const departureAgency = this.booking?.pickUp?.business?.label
      const documentType = 'PDF'
      const loginStatus = this.vehicleCardsProfileRequested ? this.userIsLogged : 'N/A'
      const page = window.location.href
      const pageTitle = document.querySelector('head title')?.text
      const pageCategory = ''
      const vehiculeModel = this.vehicle
      const payload = {
        event,
        page,
        documentType,
        departureAgency,
        loginStatus,
        pageTitle,
        pageCategory,
        vehiculeModel,
      }
      window.dataLayer.push(payload)
    },
  },
}
</script>
<style lang="scss" scoped>

.top-wrapper {
  align-items: stretch;
  display: flex;
  justify-content: space-between;
  margin: 20px 0 0;
  width: 100%;
}

h1 {
  align-items: center;
  color: black;
  display: flex;
  font-family: $f-graphie-bold;
  font-size: 2rem;
  line-height: 1;
  margin: 0;
}

.right {
  align-items: center;
  display: flex;
}

.pdf-wrapper {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 1.2rem;

  &,
  &:visited {
    color: black;
  }
}

.pdf-icon {
  height: 14px;
  margin: 0 10px 0 0;
  width: 11px;
}

.circle {
  align-items: center;
  border: solid 1.25px black;
  border-radius: 50%;
  display: flex;
  height: 33px;
  justify-content: center;
  margin: 0 0 0 20px;
  width: 33px;
}

.email-icon {
  height: 19px;
  width: 20px;
}

.fb-icon {
  height: 18px;
  width: 11px;
}

.text-popin {
  align-items: center;
  align-self: stretch;
  color: $c-nevada;
  display: flex;
  font-size: 1.6rem;
  margin-right: 20px;
  padding: 20px;
}
</style>
